import MyResumes from "./MyResumes";

export default MyResumes;
